import React, { useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { addToQueue } from "../../store/slice/ddrQueueSlice";
import { notify } from "../../utils/Notify";

interface RequestArticleDropdownProps {
  data: any;
  resultFrom?: string;
  ddrPath: string; // e.g. "DdrScreen" or "/basicSearchScreen/DdrScreen"
  size?: "small" | "medium" | "large";
}

function RequestArticleDropdown({
  data,
  resultFrom,
  ddrPath,
  size,
}: RequestArticleDropdownProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const queuePath = ddrPath.replace("DdrScreen", "DdrQueueScreen");
  const queue = useAppSelector((state) => state.ddrQueue.queue);
  const isAlreadyInQueue = queue.some(
    (item) => item.article_id === data.article_id,
  );

  const handleOpen = (e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSendNow = () => {
    handleClose();
    navigate(ddrPath, { state: { data, resultFrom } });
  };

  const handleAddToQueue = () => {
    handleClose();
    // if (isAlreadyInQueue) {
    //   notify("info", "Article is already in the DDR queue.");
    //   return;
    // }
    dispatch(addToQueue(data));
    //navigate(queuePath, { state: { data, resultFrom } });
    notify("success", "Request added to DDR cart");
  };

  return (
    <>
      <Button
        variant="outlined"
        onClick={handleOpen}
        endIcon={<ArrowDropDownIcon />}
        size={size}
      >
        Request Article
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        // disableScrollLock
        disablePortal
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        {/* <MenuItem onClick={handleAddToQueue}>Add to DDR Queue</MenuItem> */}
        <MenuItem onClick={handleAddToQueue} disabled={isAlreadyInQueue}>
          {" "}
          {isAlreadyInQueue ? "Already Added to DDR Queue" : "Add to DDR Queue"}
        </MenuItem>
        <MenuItem onClick={handleSendNow}>Send Request Now</MenuItem>
      </Menu>
    </>
  );
}

export default RequestArticleDropdown;
